<!-- <div class="clocking-bg">

	<img src="../../../../assets/Logo.png" width="200" style="margin-top:25px; margin-left:140px; margin-bottom:25px;">
	<input class="input-override" type="password" name="password" (keyup.enter)="submitData()" [(ngModel)]="fobScannedEntity.fobId" placeholder="Fob ID"
		autocomplete="off"
		style="margin-left:25px; margin-right:25px;">
		<button class="btn-override" (click)="submitData()" style="margin-left:25px; margin-top:25px;" >
			Submit Details
		</button>
</div> -->
<!-- Main page wrapper -->
<div class="clock-in-page">
  <div class="clock-in-main">

    <!-- Header -->
    <div class="clock-in-header">
      <div class="header-content">
        <div class="header-left">
          
            <img src="../../../../assets/Logo.png" width="70" style="margin-top:2px">
        </div>

        <div class="header-right">
          <div class="current-time">{{ currentTime }}</div>
          <div class="current-date">{{ currentDate }}</div>
        </div>
      </div>
    </div>

    <!-- Main content -->
    <div class="clock-main-content">
      <div class="scan-area">
        <div class="status-indicator" id="status-indicator"></div>

        <div
          class="scan-zone"
          [ngClass]="{ 'scan-zone-active': isScanZoneActive }"
          (click)="onScanZoneClick()"
        >
          <div class="scanning-animation">
            <div class="scan-icon-wrapper">
              <i class="fas fa-wifi icon-xxl"></i>
            </div>
          </div>

          <h3 class="scan-title">Awaiting Scan</h3>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="clock-in-footer">
      <div class="footer-content">
        <div class="footer-left">
          <div class="status-item">
            <div class="status-dot"></div>
            <span class="status-text">Scanner Active</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Success Modal -->
    <div *ngIf="showModal" class="modal-backdrop">
      <div class="modal-content">
		<div class="modal-icon-circle">
          <!-- <i class="fas fa-check icon-xxl"></i> -->
		   <img class="avatar" src="{{this.avatar}}">

        </div>

        <!-- <h3 class="modal-title">Clock {{this.mode}} Successful!</h3> -->
		 <h3 class="modal-title">{{this.mode == "In" ? "Welcome back" : "Goodbye"}}, {{ userName }}</h3>
        <!-- <p class="modal-subtitle">{{this.mode == "In" ? "Welcome back" : "Goodbye"}}, {{ userName }}</p> -->

        <div class="modal-info-box">
          <div class="modal-info-label" *ngIf="this.mode === 'In'" style="color:#22c55e">Clock {{this.mode}} Time</div>
		  <div class="modal-info-label" *ngIf="this.mode !== 'In'" style="color:#c52222">Clock {{this.mode}} Time</div>
          <div class="modal-info-value" *ngIf="this.mode === 'In'" style="color:#22c55e">{{ clockInTime }}</div>
		  <div class="modal-info-value" *ngIf="this.mode !== 'In'" style="color:#c52222">{{ clockInTime }}</div>
        </div>
      </div>
    </div>
	<div *ngIf="isLoading" class="modal-backdrop">
	<div class="modal-content">
		<div class="modal-icon-circle">
		<i class="fas fa-spinner icon-xxl"></i>
		</div>
		<h3 class="modal-title">Processing...</h3>
		<p class="modal-subtitle">Please wait while we record your time.</p>
	</div>
</div>
</div>
</div>
